module.exports = __webpack_public_path__ + "static/media/Firefly.b9dc25db.png";